import Car from "@/assets/icons/Car";
import AppButton from "@/components/shared/AppButton";
import { Card } from "@/components/shared/Card";
import { HStack } from "@/components/ui/hstack";
import { Skeleton, SkeletonText } from "@/components/ui/skeleton";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { useT } from "@transifex/react";

interface VehicleCardProps {
  nickname: string;
  onPress: () => void;
  plate: string;
  isLoading?: boolean;
}

const VehicleCard = ({ nickname, onPress, plate, isLoading = false }: VehicleCardProps) => {
  const t = useT();
  if (isLoading) return <VehicleCardSkeleton />;

  return (
    <Card className="py-[20px]">
      <HStack className="gap-[20px] items-center justify-between flex-wrap">
        <HStack className="gap-5 items-center flex-1">
          <VStack className="gap-[6px]">
            <Text className="font-[700] text-[18px] text-typography-900">{nickname}</Text>
            <HStack className="gap-[6px] items-center">
              <Car />
              <Text className="font-[400] text-[18px] text-typography-900">{plate}</Text>
            </HStack>
          </VStack>
        </HStack>
        <AppButton onPress={onPress} title={t("Edit")} />
      </HStack>
    </Card>
  );
};

function VehicleCardSkeleton() {
  return (
    <Card className="py-[20px]">
      <HStack className="gap-[20px] items-center justify-between flex-wrap">
        <HStack className="gap-5 items-center flex-1">
          <VStack className="gap-[6px]">
            <SkeletonText className="h-[22px] w-[160px]" />
            <HStack className="gap-[6px] items-center">
              <Skeleton className="h-[20px] w-[20px] rounded-[6px]" />
              <SkeletonText className="h-[22px] w-[100px]" />
            </HStack>
          </VStack>
        </HStack>
        <Skeleton className="h-[40px] w-[80px] rounded-[6px]" />
      </HStack>
    </Card>
  );
}

export default VehicleCard;
